export default {
    "ar": "العربية",
    "de": "Deutsch",
    "hr": "Hrvatski",
    "nl": "Nederlands",
    "fr": "Français",
    "bg": "Български",
    "tr": "Türkçe",
    "ka": "ქართული",
    "ru": "Русский",
    "sr": "Српски",
    "el": "Ελληνικά",
    "en-GB": "English",
    "cs": "Čeština",
    "sk": "Slovenčina",
    "da": "Dansk",
    "et": "Eesti",
    "fi": "Suomi",
    "hu": "Magyar",
    "ga": "Gaeilge",
    "it": "Italiano",
    "lv": "Latviešu",
    "lt": "Lietuvių",
    "lb": "Lëtzebuergesch",
    "mt": "Malti",
    "pl": "Polski",
    "pt": "Português",
    "ro": "Română",
    "sl": "Slovenščina",
    "es": "Español",
    "sv": "Svenska"
  }
  